window.Bernie = window.Bernie || {};
var mod = require("-!/app-build/node_modules/happypack/loader.js?id=ts!/app-build/src/config/get-localization.ts");
Object.keys(mod).forEach(function (key) { window.Bernie[key] = mod[key]; });
module.exports = window.Bernie;